var linkedSections = document.querySelectorAll('.linked_sections');
if(linkedSections) {
  linkedSections.forEach(link => link.addEventListener('click', scrollToSection.bind(this)));
}

function scrollToSection(evt) {
  const elmntId = evt.currentTarget.getAttribute('data-ref-id');
  const element = document.getElementById(elmntId);
  if(element) {
    element.scrollIntoView({behavior: "smooth"});
  }
}
//for scrolling in page end